import throttle from 'lodash.throttle';

export default class Header {
	constructor(elm) {
		this.elm = elm;

		document.addEventListener('bless', (e) => {
			this.init();
		});

		// Scroll Listener
		document.addEventListener(
			'scroll',
			throttle((e) => this.checkScroll(), 100)
		);
		this.prevScroll = 0;
		this.checkScroll();
	}

	init() {
		this.links = this.elm.querySelectorAll('a');
		this.links.forEach((elm) => {
			elm.addEventListener('click', (elm) => {
				this.links.forEach((elm) => {
					elm.closest('.menu-item').classList.remove('current-menu-item');
				});
				elm.target.closest('.menu-item').classList.add('current-menu-item');
			});
		});
	}

	checkScroll() {
		window.scrollY > 60 ? this.hasScrolled() : this.setTopState();
	}

	setTopState() {
		this.elm.classList.remove('has-scrolled');
	}

	hasScrolled() {
		this.elm.classList.add('has-scrolled');
	}
}
